import { render, staticRenderFns } from "./SignCompany.vue?vue&type=template&id=1ee918c4&scoped=true"
import script from "./SignCompany.vue?vue&type=script&lang=js"
export * from "./SignCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee918c4",
  null
  
)

export default component.exports